
import FindPartner from "../../components/landing/listing-locator/find-partner";
import QuotesBlock from "../../components/landing/listing-locator/quotes-block";
import ServiceFor from "../../components/landing/listing-locator/service-for";
import HowWeDo from "../../components/landing/listing-locator/how-we-do";
import blog from "../../components/landing/blog";
import Waiting from "../../components/landing/listing-locator/waiting";
import Results from "../../components/landing/listing-locator/results";
import Steps from "../../components/landing/listing-locator/steps";
import RealStories from "../../components/landing/listing-locator/real-stories.vue";
import Featured from "../../components/landing/listing-locator/featured";
import Mission from "../../components/landing/listing-locator/mission";
import AlreadyUsing from "../../components/landing/listing-locator/already-using";
import Comments from "../../components/landing/listing-locator/comments.vue";
import Overcoming from "../../components/landing/listing-locator/overcoming";
import Faq from "../../components/landing/listing-locator/faq";
import QuotesBlockKnowledge from "../../components/landing/listing-locator/quotes-block-knowledge";
import Navigation from '../../components/Navigation.vue';
import FooterMain from '../../components/FooterMain.vue';


import isMob from "@/mixins/isMob";
import authorization from "@/mixins/authorization";

export default {
  mixins: [isMob, authorization],
  mounted() {
    this.getUtm()
  },
  components: {
    FindPartner,
    QuotesBlock,
    ServiceFor,
    HowWeDo,
    blog,
    Waiting,
    Results,
    Steps,
    RealStories,
    Featured,
    Mission,
    AlreadyUsing,
    Comments,
    Overcoming,
    Faq,
    QuotesBlockKnowledge,
    Navigation,
    FooterMain,
  },

  head() {
    const title = 'Catch a Cheater in Minutes - Listing Locator App | iFindCheaters';
    const description = 'Best Cheating Tracker App 2024. Catch a Cheater in Minutes using Listing Locator App by iFindCheaters. Search by name, username, or phone number to uncover the truth. Start your investigation today and take control of your situation.';

    return {
      title: title,
      meta: [
        { charset: "utf-8" },
        { name: "viewport", content: "width=device-width, initial-scale=1" },
        { hid:'og:title', property: 'og:title', content: title },
        { hid: "description", name: "description", content: description },
        { hid: "og:description", name: "og:description", content: description },
        { hid: 'og:image',  property: 'og:image', content: '/products/find-someone-cheating-online-for-free/og.png' },
        { hid: 'twitter:title', name: 'twitter:title', content: title },
        { hid:'og:site_name', property: 'og:site_name', content: 'ifindcheaters.com' },
        { hid: 'og:keywords', name: 'og:keywords', content: 'secret profile finder, search people on dating sites, search for someone on dating sites, search dating profiles, is my husband on dating sites, find hidden dating profiles, find my wife on dating sites, catch a cheating spouse, find spouse on dating sites, Catch cheating partner online, Online infidelity search, find out if my boyfriend or girlfriend is on dating sites, how to find spouse on dating sites, is my wife on dating sites or apps, free dating profiles search by email' },
      ],
      link: [
        {
          hid: "preload",
          rel: "preload",
          as: "image",
          href: "@/assets/animations/ll.png",
        },
        {
          hid: "canonical",
          rel: "canonical",
          href: "https://ifindcheaters.com/products/listing-locator/",
        },
      ],
      script: [
        {
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "iFindCheaters",
              "item": "https://ifindcheaters.com/"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "Products",
              "item": "https://ifindcheaters.com/products/"
            },{
              "@type": "ListItem",
              "position": 3,
              "name": "Listing Locator - Search For Someone And Verify Your Spouse"
            }]
          }
        },{
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org/",
            "@type": "Product",
            "name": "Listing Locator - Search For Someone And Verify Your Spouse",
            "sku": "004",
            "image": "https://ifindcheaters.com/img/logo.png",
            "description": description,
            "brand": {
              "@type": "Brand",
              "name": "iFindCheaters"
            },
              "offers": {
              "@type": "Offer",
              "url": "https://ifindcheaters.com/products/listing-locator/",
              "priceCurrency": "USD",
              "price": "7.99",
              "priceValidUntil": "2022-05-25",
              "itemCondition": "https://schema.org/UsedCondition",
              "availability": "https://schema.org/InStock",
              "seller": {
              "@type": "Organization",
              "name": "iFindCheaters"
              }},
              "review": [{
              "@type": "Review",
              "reviewRating": {
                "@type": "Rating",
                "ratingValue": "5",
                "bestRating": "5"
              },
              "author": {
                "@type": "Person",
                "name": "Aaliya J."
              },
              "datePublished": "2022-05-07T10:07:30+00:00",
              "reviewBody": "He was married!!! Made a lot of big talks but something just seemed off, so I used the Listing Locator. Glad I found out now instead of later."
            },{
              "@type": "Review",
              "reviewRating": {
                "@type": "Rating",
                "ratingValue": "5",
                "bestRating": "5"
              },
              "author": {
                "@type": "Person",
                "name": "Susan H."
              },
            "datePublished": "2020-12-13T15:45:29+00:00",
            "reviewBody": "He hadn’t said anything about having kids. That is the sort of thing you should let someone know."
            }],
              "aggregateRating": {
              "@type": "AggregateRating",
              "bestRating": "5",
              "ratingValue": "4.8",
              "reviewCount": "78"
              }
            }
          }
      ]
    }
  },

};
